<template>
    <v-tooltip bottom max-width="500">
        <template v-slot:activator="{on}">
            <v-icon v-on="on">mdi-information-outline</v-icon>
        </template>
        <span>En este apartado se eligen los diferentes materiales que forman parte de la solución constructiva.</span>
    </v-tooltip>
</template>

<script>
export default {
name: "TooltipInfoComponentes"
}
</script>

<style scoped>

</style>